export interface JwtCliengoPayload {
  privileges: string[];
  v: number;
  company: string;
  websites: unknown[];
  user: string;
  timestamp: number;
}

const JwtCliengoPayloadKeys: Array<keyof JwtCliengoPayload> = [
  'privileges',
  'v',
  'company',
  'websites',
  'user',
  'timestamp',
];

export function instanceOfJwtCliengoPayload(
  data: unknown
): data is JwtCliengoPayload {
  if (!data || typeof data !== 'object') {
    return false;
  }

  for (const key of JwtCliengoPayloadKeys) {
    if (!(key in (data as JwtCliengoPayload))) {
      return false;
    }
  }
  return true;
}
